<!-- No Layer Template -->

<!-- No Image Template -->

<!-- Wysiwyg -->
<ng-template #wysiwyg_template
  let-wysiwygPanelData="wysiwygPanelData">
  <div class="flex flex-1 overflow-auto justify-content-center">
    <medsurf-slide-wysiwyg [hidden]="wysiwygPanelData.isMinimized"
    class="flex w-full h-auto"></medsurf-slide-wysiwyg>
  </div>
</ng-template>

<!-- Media -->
<ng-template #media_template>
  @if (slideAuthorFacade.currentSelectedSlideLayer$ | async; as layer) {
    @if (slideAuthorFacade.currentSelectedSlideMedia$ | async; as media) {
      <!-- Video -->
      @if (mediaControlService.isVideo(media)) {
        <medsurf-video
        class="flex w-full h-auto"></medsurf-video>
      }
      <!-- Audio -->
      @if (mediaControlService.isAudio(media)) {
        <medsurf-audio
        class="flex w-full h-auto"></medsurf-audio>
      }
      <!-- Image -->
      @if (mediaControlService.isDeepzoom(media) || mediaControlService.isImage(media)) {
        <medsurf-image
        class="flex w-full h-auto"></medsurf-image>
      }
    } @else {
      <div class="flex flex-grow-1 flex-shrink-1 flex-column row-gap-1 drag-node">
        <div class="flex flex-grow-1 flex-row column-gap-1 justify-content-center align-items-center p-1 pl-2">
          <div class="flex p-2">
            <button medsurf-design-input-button [id]="'image_add'"
              [label]="'global.media_add' | translate"
              [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.MEDIA_VISUAL"
            (click)="chooseMedia()"></button>
          </div>
        </div>
      </div>
    }
  } @else {
    <div class="flex flex-grow-1 flex-shrink-1 flex-column row-gap-1 drag-node">
      <div class="flex flex-grow-1 flex-row column-gap-1 justify-content-center align-items-center p-1 pl-2">
        <div class="flex p-2">
          <button medsurf-design-input-button [id]="'image_add'"
            [label]="'global.media_add' | translate"
            [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.MEDIA_VISUAL"
          (click)="chooseMedia()"></button>
        </div>
      </div>
    </div>
  }
</ng-template>

<!-- Content -->
@if (slideAuthorFacade.wysiwygPanelData$ | async; as wysiwygPanelData) {
  <div
    class="flex flex-1 flex-column m-2">
    <medsurf-slide-main-toolbar></medsurf-slide-main-toolbar>
    @if (slideAuthorFacade.mainPanelDisplay$ | async; as mainPanelDisplay) {
      @switch (mainPanelDisplay) {
        @case (FlatModels.SlideAuthorModels.MainPanelDisplay.enum.image) {
          <div
            class="flex flex-1 overflow-hidden justify-content-center">
            <ng-container *ngTemplateOutlet="media_template"></ng-container>
          </div>
        }
        @case (FlatModels.SlideAuthorModels.MainPanelDisplay.enum.text) {
          <div
            class="flex flex-1 overflow-hidden justify-content-center">
            <ng-container *ngTemplateOutlet="wysiwyg_template;context:{wysiwygPanelData}"></ng-container>
          </div>
        }
        @case (FlatModels.SlideAuthorModels.MainPanelDisplay.enum.all) {
          <p-splitter
            class="flex flex-1 h-full overflow-hidden justify-content-center"
            styleClass="w-full"
            panelStyleClass="min-w-4_5rem"
            [gutterSize]="FlatModels.PanelDesignModels.panelGutterSizeBig"
            [panelSizes]="wysiwygPanelData.panelSize"
            [minSizes]="[FlatModels.PanelDesignModels.panelMinSizeSmall, FlatModels.PanelDesignModels.panelMinSizeMain]"
            [layout]="'horizontal'"
            (onResizeStart)="wysiwygOnResizeStart()"
            (onResizeEnd)="wysiwygOnResizeEnd($event)">
            <ng-template pTemplate>
              <ng-container *ngTemplateOutlet="wysiwyg_template;context:{wysiwygPanelData}"></ng-container>
            </ng-template>
            <ng-template pTemplate>
              <ng-container *ngTemplateOutlet="media_template"></ng-container>
            </ng-template>
          </p-splitter>
        }
      }
    }
  </div>
}
